//imports
import React, { useCallback, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Tabs, { TabContainer } from 'Components/Tabs';
import { useIntl } from 'react-intl';
import { HasPermission } from "Core/security";
//Views
import FsmSettings from '../fsmSettings';
import FsmMessages from '../fsmMessages';
import FsmRoutes from '../fsmRoutes';

import {
    openSettingsFsm
} from 'Redux/actions';


const FsmMainView = (props) => {
    //intl
    const dispatch = useDispatch();
    const user = useSelector(state => state.securityRedux.user)
    //Global state
    const { messages } = useIntl();
    const [tabs, setTab] = useState(0);

    const handleClose = useCallback(() => {
        setTab(tabs)
        dispatch(openSettingsFsm(false));
    });

    useEffect(() => {
        let valueTab = 0;
        if(HasPermission(user, "", [60]) && HasPermission(user, "", [61]) || HasPermission(user, "", [124]) && HasPermission(user, "", [61])){
            valueTab=2;
        }else  if(HasPermission(user, "", [60]) || HasPermission(user, "", [61]) || HasPermission(user, "", [124])) {
            valueTab=1;
        }

        if (tabs === valueTab) {
            dispatch(openSettingsFsm(true));
            setTab(0)
        }
    }, [tabs]);

    return (
        <div className="fsm-container-tabs">
            <Tabs
                tab={tabs}
                border
                onChange={(newTab) => {
                    setTab(newTab)
                }}
            >
                {
                    HasPermission(user, "", [60]) &&
                    <TabContainer
                        label={messages['fsm_messages']}
                        index={0}
                        flagRender={0}
                        style={{ paddingLeft: 0, paddingRight: 0 }}
                    >
                        <FsmMessages />
                    </TabContainer>
                }
                {
                    HasPermission(user, "", [124]) && !HasPermission(user, "", [60]) &&
                    <TabContainer
                        label={messages['fsm_messages']}
                        index={0}
                        style={{ paddingLeft: 0, paddingRight: 0 }}
                    >
                        <FsmMessages />
                    </TabContainer>
                }
                {
                    HasPermission(user, "", [61]) &&
                    <TabContainer
                        label={messages['fsm_routes']}
                        index={1}
                        flagRender={1}
                        style={{ paddingLeft: 0, paddingRight: 0 }}
                    >
                        <FsmRoutes />
                    </TabContainer>
                }
                {
                    HasPermission(user, "", [62]) &&
                    <TabContainer
                        label={messages['fsm_settings']}
                        index={2}
                        flagRender={2}
                        style={{ paddingLeft: 0, paddingRight: 0 }}
                    >
                    </TabContainer>
                }

            </Tabs>
            <FsmSettings handleClose={handleClose} />
        </div>
    );
}

export default FsmMainView;